import { frontendURL } from 'dashboard/helper/URLHelper';
import AppointmentsLayout from './AppointmentsLayout.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      component: AppointmentsLayout,
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: FEATURE_FLAGS.APPOINTMENTS_MODULE,
      },
      children: [
        {
          path: '',
          name: 'appointments_root',
          redirect: { name: 'appointments_agenda' },
        },
        {
          path: 'agenda',
          name: 'appointments_agenda',
          component: () => import('./AppointmentsAgenda.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'clients',
          name: 'appointments_clients',
          component: () => import('./AppointmentsClientsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'professionals',
          name: 'appointments_professionals',
          component: () => import('./AppointmentsProfessionalsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'services',
          name: 'appointments_services',
          component: () => import('./AppointmentsServicesList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'partners',
          name: 'appointments_partners',
          component: () => import('./AppointmentsPartnersList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'reports',
          name: 'appointments_reports',
          component: () => import('./AppointmentsReports.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
      ],
    },
  ],
};
